import { AlertTitle } from '@mui/material'
import { styled } from '@mui/system'
import { forwardRef, MouseEventHandler } from 'react'
import { Button } from '../../core/Button'
import { NotificationSeverities } from '../../core/Notification'
import { NotificationIcon } from '../common/NotificationIcon'

const StyledWrapper = styled('div')(
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  { name: 'NotificationContent', slot: 'mainWrapper' }
)

const StyledInnerWrapper = styled('div')(
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  { name: 'NotificationContent', slot: 'innerWrapper' }
)

const StyledMessageWrapper = styled('div')(
  {
    alignItems: 'flex-start',
    alignSelf: 'flex-end',
  },
  { name: 'NotificationContent', slot: 'messageWrapper' }
)

const StyledInnerMessageWrapper = styled('div')(
  {
    marginTop: 4,
  },
  { name: 'NotificationContent', slot: 'messageInnerWrapper' }
)

const StyledButtonWrapper = styled('div')(
  {
    marginTop: 12,
    display: 'flex',
    gap: 4,
  },
  { name: 'NotificationContent', slot: 'buttonWrapper' }
)

interface NotificationContentProps {
  title: string
  message: string
  severity: NotificationSeverities
  primaryButtonLabel: string | undefined
  secondaryButtonLabel: string | undefined
  onClickPrimaryButton: MouseEventHandler | undefined
  onClickSecondaryButton: MouseEventHandler | undefined
}

// Need to add two buttons
export const NotificationContent = forwardRef<HTMLDivElement, NotificationContentProps>((props, ref) => {
  void ref
  const {
    title,
    message,
    severity,
    onClickPrimaryButton,
    onClickSecondaryButton,
    primaryButtonLabel,
    secondaryButtonLabel,
  } = props
  const showPrimaryButton = onClickPrimaryButton || primaryButtonLabel
  const showSecondaryButton = onClickSecondaryButton || secondaryButtonLabel
  const showButtons = showPrimaryButton || showSecondaryButton

  return (
    <StyledWrapper>
      <StyledInnerWrapper>
        <NotificationIcon severity={severity} />
        <StyledMessageWrapper>
          <AlertTitle>{title}</AlertTitle>
          <StyledInnerMessageWrapper>{message}</StyledInnerMessageWrapper>
          {showButtons && (
            <StyledButtonWrapper>
              {showPrimaryButton && (
                <Button color="info" variant="outlined" size="xSmall" onClick={onClickPrimaryButton}>
                  {primaryButtonLabel}
                </Button>
              )}
              {showSecondaryButton && (
                <Button color="info" variant="text" size="xSmall" onClick={onClickSecondaryButton}>
                  {secondaryButtonLabel}
                </Button>
              )}
            </StyledButtonWrapper>
          )}
        </StyledMessageWrapper>
      </StyledInnerWrapper>
    </StyledWrapper>
  )
})
